import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
import { VariantPackDetailedCostChangeDataFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/screens/management/blocs/documents/variant-pack-cost-change-data-fragments.generated';
const defaultOptions = {} as const;

export const GetPricingBookmarksDocument = gql`
  query GetPricingBookmarks {
    getPricingBookmarks {
      bookmarks {
        ...VariantPackDetailedCostChangeDataFields
        bookmark_note
        bookmarked_at
      }
    }
  }
  ${VariantPackDetailedCostChangeDataFieldsFragmentDoc}
`;
export function useGetPricingBookmarksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >(GetPricingBookmarksDocument, options);
}
export function useGetPricingBookmarksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >(GetPricingBookmarksDocument, options);
}
export type GetPricingBookmarksQueryHookResult = ReturnType<
  typeof useGetPricingBookmarksQuery
>;
export type GetPricingBookmarksLazyQueryHookResult = ReturnType<
  typeof useGetPricingBookmarksLazyQuery
>;
export type GetPricingBookmarksQueryResult = Apollo.QueryResult<
  Types.GetPricingBookmarksQuery,
  Types.GetPricingBookmarksQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingBookmarksQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingBookmarksQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >(GetPricingBookmarksDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingBookmarksLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingBookmarksLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingBookmarksQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingBookmarksQuery,
    Types.GetPricingBookmarksQueryVariables
  >(GetPricingBookmarksDocument, lazyOptions);
}
